/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import ModularOnboardingModuleRenderer from 'bundles/onboarding-common/module-renderers/ModularOnboardingModuleRenderer';
import { getShouldShowModularOnboarding } from 'bundles/onboarding-common/utils/experimentUtils';

const ModularOnboardingPlayground = () => {
  if (!getShouldShowModularOnboarding()) {
    return null;
  }
  return (
    <div
      style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', maxWidth: '1344px', margin: '0 auto' }}
    >
      <h1>Modular Onboarding Playground</h1>
      <h3 style={{ alignSelf: 'flex-start', marginBottom: '10px' }}>LIHP_HOME Default</h3>
      <ModularOnboardingModuleRenderer entrypoint="LIHP_HOME" />

      <h3 style={{ alignSelf: 'flex-start', marginBottom: '10px' }}>LIHP_HOME with inferred role</h3>
      <ModularOnboardingModuleRenderer
        entrypoint="LIHP_HOME"
        inferredRole={{ id: 'data-scientist', name: 'Data Scientist' }}
      />
      <h3 style={{ alignSelf: 'flex-start', marginBottom: '10px' }}>RDP Default</h3>
      <ModularOnboardingModuleRenderer
        entrypoint="RDP"
        inferredRole={{ id: 'data-analyst', name: 'Data Analyst' }}
        onOnboardingCompletionSuccess={() => {
          window.location.reload();
        }}
      />
      <h3 style={{ alignSelf: 'flex-start', marginBottom: '10px' }}>
        Generic module with success message on completion
      </h3>
      <ModularOnboardingModuleRenderer entrypoint="SEARCH" shouldShowSuccessMessageOnCompletion />
      <h3 style={{ alignSelf: 'flex-start', marginBottom: '10px' }}>
        Inferred role module with success message on completion with custom styles
      </h3>
      <ModularOnboardingModuleRenderer
        css={css`
          margin: 0 auto;
        `}
        entrypoint="SEARCH"
        inferredRole={{ id: 'project-manager', name: 'Project Manager' }}
        shouldShowSuccessMessageOnCompletion
      />
    </div>
  );
};

export default ModularOnboardingPlayground;
